<template>
    <div class="components-container">
        <div>
            <el-row>
                <div class="titles">
                    <span class="fonts">职业素养</span>
                    <el-button @click="addElement('quality')" type="success" size="mini" style="margin-left:15px;" :disabled="editDisableState">
                        <i class="el-icon-plus"></i>
                    </el-button>
                    <el-button @click="popGrid('quality')" type="danger" size="mini" :disabled="editDisableState">
                        <i class="el-icon-minus"></i>
                    </el-button>
                </div>
            </el-row>
            <el-table
                :data="quality"
                ref="qualityTable"
                class="tb-edit"
                :header-cell-style="{ 'text-align': 'center' }"
                element-loading-text="信息加载中"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
                :show-header="false"
                :row-style="{ height: '65px' }"
                @row-click="(row, column, event) => handleRowClick('qualityTable', row, column, event)"
                @selection-change="handleQualitySelection"
                style="width: 100%"
            >
                <el-table-column type="selection" width="55px">
                </el-table-column>
                <el-table-column label="职业素养" prop="jzSm">
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-input
                                type="textarea"
                                autosize
                                placeholder="请输入内容"
                                v-model="scope.row.jzSm"
                            >
                            </el-input>
                        </span>
                        <span>{{ scope.row.jzSm }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="ability">
            <el-row>
                <div class="titles">
                    <span class="fonts">职业能力</span>
                    <el-button @click="addElement('ability')" type="success" size="mini" style="margin-left:15px;" :disabled="editDisableState">
                        <i class="el-icon-plus"></i>
                    </el-button>
                    <el-button @click="popGrid('ability')" type="danger" size="mini" :disabled="editDisableState">
                        <i class="el-icon-minus"></i>
                    </el-button>
                </div>
            </el-row>
            <el-table
                :data="ability"
                ref="abilityTable"
                class="tb-edit"
                :header-cell-style="{ 'text-align': 'center' }"
                element-loading-text="信息加载中"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
                :show-header="false"
                :row-style="{ height: '65px' }"
                @row-click="(row, column, event) => handleRowClick('abilityTable', row, column, event)"
                @selection-change="handleAbilitySelection"
                style="width: 100%"
            >
                <el-table-column type="selection" width="55px"></el-table-column>
                <el-table-column label="职业能力">
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-input
                                type="textarea"
                                autosize
                                placeholder="请输入内容"
                                v-model="scope.row.jzSm"
                            >
                            </el-input>
                        </span>
                        <span>{{ scope.row.jzSm }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: ["editDisableState"],
    data() {
        return {
            quality: [],
            qualityMult: [],
            ability: [],
            abilityMult: [],
        };
    },
    mounted() {},
    methods: {
        addElement(type) {
            if (type == "quality") {
                let origin = {
                    id: this.getId(6),
                    jzSm: "",
                    jzLx: "1",
                };
                let copy = { ...origin };
                this.quality.push(copy);
                this.$refs.qualityTable.setCurrentRow(copy);
                this.handleRowClick("qualityTable");
            }

            if (type == "ability") {
                let origin = {
                    id: this.getId(6),
                    jzSm: "",
                    jzLx: "2",
                };
                let copy = { ...origin };
                this.ability.push(copy);
                this.$refs.abilityTable.setCurrentRow(copy);
                this.handleRowClick("abilityTable");
            }
        },
        handleQualitySelection(val) {
            this.qualityMult = val;
        },
        handleAbilitySelection(val) {
            this.abilityMult = val;
        },
        popGrid(type) {
            if (type == "quality") {
                if (this.qualityMult.length == 0) return;
                this.arrayMinus(this.quality, this.qualityMult);
                this.$nextTick(() => {
                    this.$refs.qualityTable.clearSelection();
                });
            }
            if (type == "ability") {
                if (this.abilityMult.length == 0) return;
                this.arrayMinus(this.ability, this.abilityMult);
                this.$nextTick(() => {
                    this.$refs.abilityTable.clearSelection();
                });
            }
        },
        arrayMinus(arr1, arr2) {
            arr1.forEach((item) => {
                item.id = this.getId();
            });
            arr2.forEach((item) => {
                item.id = this.getId();
            });
            //arr1 - arr2
            for (let i = arr1.length - 1; i >= 0; i--) {
                let x = arr1[i].id;
                for (let k = arr2.length - 1; k >= 0; k--) {
                    let y = arr2[k].id;
                    if (x == y) {
                        arr1.splice(i, 1);
                        arr2.splice(k, 1);
                        break;
                    }
                }
            }
        },
        getId(length) {
            return Number(
                Math.random().toString().substr(3, length) + Date.now()
            ).toString(36);
        },
        handleRowClick(refName, row, column, event) {
            //不可编辑处理
            if(this.editDisableState){
                this.$refs[refName].setCurrentRow();
            }
            this.$emit("changeEditRow", refName);
        },
    },
};
</script>

<style scoped>
    .ability {
        margin-top: 30px;
    }

    .tb-edit .el-edit {
        display: none;
    }

    .tb-edit .current-row .el-edit {
        display: block;
    }

    .tb-edit .current-row .el-edit + span {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// talent.vue?52876ce1